<template>
  <v-app class="app-shell">
    <div class="app-shell__ambient"></div>
    <v-main class="app-shell__main">
      <router-view name="router1" />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    //
  }),
};
</script>
<style scoped>
.app-shell {
  position: relative;
  min-height: 100vh;
  background: transparent;
}

.app-shell__ambient {
  position: fixed;
  inset: 0;
  background:
    radial-gradient(circle at top left, rgba(20, 184, 166, 0.16), transparent 30%),
    radial-gradient(circle at top right, rgba(59, 130, 246, 0.12), transparent 32%),
    linear-gradient(180deg, #f8fbff 0%, #eef3f9 48%, #f7fafc 100%);
  pointer-events: none;
  z-index: 0;
}

.app-shell__main {
  position: relative;
  z-index: 1;
}
</style>
